import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const TooltipWrapper = styled.span`
  position: relative;
  display: inline-block;
`

export const TooltipContent = styled.div`
  position: fixed;
  width: 16rem;
  padding: 0.75rem;
  font-family: ${themeGet('fontFamily')};
  color: ${themeGet('colors.darkGray')};
  background-color: ${themeGet('colors.rosterTooltipBackground')};
  border: 1px solid ${themeGet('colors.tabBorder')};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10000;
`

export const RoleDescription = styled.div`
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  white-space: pre-line;

  &:last-child {
    margin-bottom: 0;
  }

  strong {
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.9375rem;
    text-decoration: underline;
  }
`

export const TooltipIcon = styled.i.attrs(() => ({
  className: 'fas fa-question-circle',
}))`
  margin-left: 0.375rem;
  color: ${themeGet('colors.gray600')};
  cursor: pointer;

  &:hover {
  }
`
